import { z } from 'zod';

// Mirrors the backend `ContributionTimeline` DTO returned by
// GET /job-architectures/contributions/timeline. Counts are tenant-wide and bucketed by
// local calendar date (in the requested timezone). `date`, `from` and `to` are ISO LocalDate
// strings (e.g. "2026-06-03"), so they are kept as plain strings.
export const contributionTimelineDaySchema = z.object({
    assignedToReviewers: z.number().int().nonnegative(),
    commentsCreated: z.number().int().nonnegative().default(0),
    commentsResolved: z.number().int().nonnegative().default(0),
    date: z.string(),
    levelsCreated: z.number().int().nonnegative(),
    reviewed: z.number().int().nonnegative(),
    rolesCreated: z.number().int().nonnegative(),
    total: z.number().int().nonnegative(),
    versionsCreated: z.number().int().nonnegative(),
});

export const contributionTimelineSchema = z.object({
    days: z.array(contributionTimelineDaySchema),
    from: z.string(),
    timezone: z.string(),
    to: z.string(),
});

export type ContributionTimelineDay = z.infer<typeof contributionTimelineDaySchema>;
export type ContributionTimeline = z.infer<typeof contributionTimelineSchema>;
